module.exports = __webpack_public_path__ + "static/ppc-slider-left-21811994957609f6761cc7138d24e499.svg";